import { CSSObject } from '@emotion/react';
import { HoneycombTheme, SpacingValue, TypographySizeProps } from '../../types';
import { createResponsiveStyles, getSizeValue } from '../../utils';

export function getGutterStyles(theme: HoneycombTheme) {
    return (value: SpacingValue) => {
        const padding = theme.fn.getSpacingValue(value);
        return {
            paddingLeft: `${padding} !important`,
            paddingRight: `${padding} !important`,
        };
    };
}

export function getContentMarginStyles() {
    return (value: number) => {
        const padding = getSizeValue(value);
        return {
            paddingLeft: padding,
            paddingRight: padding,
        };
    };
}

const getVariantStyles = (values: TypographySizeProps): CSSObject => {
    const { fontSize, lineHeight, letterSpacing } = values;
    return {
        '--hc-font-size': fontSize,
        '--hc-line-height': lineHeight,
        '--hc-letter-spacing': letterSpacing,
    };
};

export const getVariantFamilyStyles = (
    family: 'body' | 'caption' | 'heading' | 'hero' | 'price',
    theme: HoneycombTheme
): CSSObject => {
    // 'caption' currently reuses 'body' sizing
    const variantSizes = theme.typography.variant[family === 'caption' ? 'body' : family];

    return Object.entries(variantSizes).reduce((acc, entries) => {
        const [key, sizeProps] = entries;

        return {
            ...acc,
            [`[data-${family}-${key}]`]: {
                ...createResponsiveStyles(
                    [
                        {
                            value: sizeProps,
                            getStyles: getVariantStyles,
                        },
                    ],
                    theme
                ),
            },
        };
    }, {});
};
